<div class="game-stat" *ngIf="statistic">
  <div class="stats-values">
    <div class="stat-row">
      <div class="value">{{ statistic.team.totalShots || 0 }}</div>
      <div class="name">Броски</div>
      <div class="value">{{ statistic.competitorTeam.totalShots || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.shotsOnGoal || 0 }}</div>
      <div class="name">Броски в створ</div>
      <div class="value">{{ statistic.competitorTeam.shotsOnGoal || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.totalGoalsPercent || 0 }}%</div>
      <div class="name">Процент реализации</div>
      <div class="value">{{ statistic.competitorTeam.totalGoalsPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.ppGoals || 0 }}</div>
      <div class="name">Шайбы в большинстве</div>
      <div class="value">{{ statistic.competitorTeam.ppGoals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.shGoals || 0 }}</div>
      <div class="name">Шайбы в меньшинстве</div>
      <div class="value">{{ statistic.competitorTeam.shGoals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.penaltyMinutes || 0 }}</div>
      <div class="name">Штрафное время</div>
      <div class="value">{{ statistic.competitorTeam.penaltyMinutes || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.totalSaves || 0 }}</div>
      <div class="name">Количество отраженных бросков</div>
      <div class="value">{{ statistic.competitorTeam.totalSaves || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.totalSavesPercent || 0 }}%</div>
      <div class="name">Процент отраженных бросков</div>
      <div class="value">{{ statistic.competitorTeam.totalSavesPercent || 0 }}%</div>
    </div>
  </div>
</div>
